export class WhiteLabel {
  id: number;
  name: string;
  code: string;
  logo: string;
  logo_header: string;
  display_header: boolean;
  display_splashscreen: boolean;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/white-label.entity.ts